import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["templateId", "content", "abcTemplates", "popTemplates", "filterLink", "name", "search"]
  static values = {
    filter: { type: String, default: "abc_asc" },
    selectedTemplateId: { type: String, default: "" },
    selectedTemplateIndex: { type: Number, default: 0 },
    ascTemplates: Array,
    popTemplates: Array
  }

  connect() {
    // Parse the JSON strings into arrays
    this.ascTemplatesValue = JSON.parse(this.element.dataset.templateChooserAscArticleTemplatesValue)
    this.popTemplatesValue = JSON.parse(this.element.dataset.templateChooserPopArticleTemplatesValue)

    if (this.ascTemplatesValue[0]) {
      this.selectedTemplateIdValue = this.ascTemplatesValue[0].id
      this.nameTarget.value = this.ascTemplatesValue[0].name
      this.updateContent()
    }

    // Add search input listener
    this.searchTarget.addEventListener('input', this.handleSearch.bind(this))
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase()
    const currentTemplates = this.filterValue === "abc_asc" ? this.ascTemplatesValue : this.popTemplatesValue
    const templateContainer = this.filterValue === "abc_asc" ? this.abcTemplatesTarget : this.popTemplatesTarget
    const templates = templateContainer.querySelectorAll('.template_chooser__template')

    templates.forEach((template, index) => {
      const templateName = currentTemplates[index].name.toLowerCase()
      const isVisible = templateName.includes(searchTerm)
      template.style.display = isVisible ? '' : 'none'
    })

    // Select first visible template
    const firstVisibleTemplate = templateContainer.querySelector('.template_chooser__template:not([style*="display: none"])')
    if (firstVisibleTemplate) {
      this.chooseTemplate({ preventDefault: () => {}, currentTarget: firstVisibleTemplate })
    }
  }

  changeFilter(event) {
    event.preventDefault()
    const newFilter = event.currentTarget.dataset.filter
    this.filterValue = newFilter
    this.selectedTemplateIndexValue = 0

    // Update filter link states
    this.filterLinkTargets.forEach(link => {
      link.classList.toggle('selected', link.dataset.filter === newFilter)
    })

    if (this.filterValue === "abc_asc") {
      this.selectedTemplateIdValue = this.ascTemplatesValue[0].id
      this.abcTemplatesTarget.classList.remove("hidden")
      this.popTemplatesTarget.classList.add("hidden")
    } else {
      this.selectedTemplateIdValue = this.popTemplatesValue[0].id
      this.abcTemplatesTarget.classList.add("hidden")
      this.popTemplatesTarget.classList.remove("hidden")
    }

    // Reset selected state on templates
    const currentTemplates = this.filterValue === "abc_asc" ?
      this.abcTemplatesTarget.querySelectorAll('.template_chooser__template') :
      this.popTemplatesTarget.querySelectorAll('.template_chooser__template')

    currentTemplates.forEach((template, index) => {
      template.classList.toggle('selected', index === 0)
    })

    this.updateContent()
  }

  chooseTemplate(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index)
    const id = event.currentTarget.dataset.templateId

    this.selectedTemplateIdValue = id
    this.selectedTemplateIndexValue = index

    // Update selected class for the current filter's templates
    const container = event.currentTarget.closest('[data-template-chooser-target]')
    const templates = container.querySelectorAll('.template_chooser__template')
    templates.forEach(t => t.classList.remove('selected'))
    event.currentTarget.classList.add('selected')

    // Set the name field to the selected template's name
    const currentTemplates = this.filterValue === "abc_asc" ? this.ascTemplatesValue : this.popTemplatesValue
    this.nameTarget.value = currentTemplates[index].name

    this.updateContent()
  }

  updateContent() {
    this.templateIdTarget.value = this.selectedTemplateIdValue
    const templates = this.filterValue === "abc_asc" ? this.ascTemplatesValue : this.popTemplatesValue
    const template = templates[this.selectedTemplateIndexValue]

    if (template) {
      this.contentTarget.innerHTML = `
        <h1 class="template_chooser__content__title">${template.name}</h1>
        <div>${template.content}</div>
      `
    }
  }
}
